// Intl.DisplayNames is the built-in ISO-3166 code -> country-name map (no data
// file, no dependency). Module-level so it's built once and reused.
const REGION_NAMES = new Intl.DisplayNames(["en"], { type: "region" })

// Regional-indicator offset: 'A' (0x41) maps to 🇦 (0x1F1E6).
const REGIONAL_INDICATOR_OFFSET = 0x1f1e6 - 0x41

// countryName turns an ISO alpha-2 code into its English name, falling back to
// the raw code for anything Intl can't resolve.
export function countryName(code: string): string {
  try {
    return REGION_NAMES.of(code.toUpperCase()) ?? code
  } catch {
    return code
  }
}

// countryFlagEmoji turns an ISO alpha-2 code into its flag emoji by mapping
// each letter to its regional-indicator symbol (e.g. "PK" -> 🇵🇰). Returns ""
// for anything that isn't two ASCII letters, so callers can fall back.
export function countryFlagEmoji(code: string): string {
  const cc = code.toUpperCase()
  if (!/^[A-Z]{2}$/.test(cc)) return ""
  return String.fromCodePoint(
    cc.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET,
    cc.charCodeAt(1) + REGIONAL_INDICATOR_OFFSET,
  )
}
